import isDocumentMapDataPoint from "./isDocumentMapDataPoint";
import isNodeSource from "./isNodeSource";
export default (item) => isNodeSource(item)
    ? item
    : isDocumentMapDataPoint(item)
        ? item.NodeSource
        : undefined;
